import { connect } from 'react-redux';
import { toggleModal, toggleSnackBar, getBranchesV2 } from 'state/callers';
import {
  contributorsByIdSelector,
  selectedTeamContributorsSelector
} from 'state/selectors/contributors';
import {
  getLatestIterationEndDateSelector,
  getLatestIterationSelector,
  oneBeforeLatestOrLatestIterationSelector
} from 'state/selectors/iterations-picker';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { myAccountSelector } from 'state/selectors/account';
import Branches from './Branches';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { clearBranchesV2 } from 'state/actions';

const mapStateToProps = state => {
  const { branchesV2, repositories, organization, currentTeams } = state;

  return {
    contributorsById: contributorsByIdSelector(state),
    repositories,
    currentTeams,
    branchesV2,
    organization,
    latestIterationEndDate: getLatestIterationEndDateSelector(state),
    latestIteration: getLatestIterationSelector(state),
    contributors: selectedTeamContributorsSelector(state),
    oneBeforeLatestOrLatestIteration:
      oneBeforeLatestOrLatestIterationSelector(state),
    selectedTeam: selectedTeamSelector(state),
    isTeamLicense: isTeamLicenseSelector(state),
    selectedTeamContributors: selectedTeamContributorsSelector(state),
    gitIntegrations: gitIntegrationsSelector(state),
    myAccount: myAccountSelector(state),
    license: licenseSelector(state)
  };
};

const mapDispatchToProps = {
  getBranchesV2,
  toggleModal,
  toggleSnackBar,
  clearBranchesV2
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Branches, 'Branches'));
